/**
 * V3.1.3 一屏开场引导（EDG-585，fe-spec §2.2 / §3.4）。
 * 完全取代 V3.0.4 两步 handoff tour（D16）。
 */

/** 本地预约 / 兑现状态（§2.4）：只有 onboarding 首付费墙会写 `pending` */
export type OnepageGuideFlag = "pending" | "seen";

/** 下一步 CTA 的落点（`handoff_complete.ended_on`） */
export type OnepageGuideEndedOn = "plan" | "brief";

/** 引导弹出时所在的一级 tab（`handoff_start.landing_tab`） */
export type OnepageGuideLandingTab = "brief" | "plan" | "invest" | "track";

export interface OnepageGuideState {
  active: boolean;
  hasGoal: boolean;
  /** 读 goal 超 3s（§3.6） */
  degraded: boolean;
  landingTab: OnepageGuideLandingTab;
  /** 弹出时刻（epoch ms），计算 `handoff_skip.dwell_ms` */
  shownAt: number;
  reducedMotion: boolean;
}

/** 锚点属性（D19）：H5 底栏药丸 / PC 四个主导航项 = `nav`；Ed 圆钮 / `Chat with Ed` = `ed_entry` */
export const GUIDE_ANCHOR_ATTR = "data-guide-anchor";

export const GUIDE_ANCHOR = {
  nav: "nav",
  edEntry: "ed_entry",
} as const;

export type GuideAnchorId = (typeof GUIDE_ANCHOR)[keyof typeof GUIDE_ANCHOR];

/** 锚点轮询间隔与放弃时长（沿用旧 handoff 100ms / 1.5s） */
export const GUIDE_ANCHOR_POLL_MS = 100;
export const GUIDE_ANCHOR_READY_TIMEOUT_MS = 1500;

/** has_goal 判定上限（D17 / §3.4.1）：超时按无 goal + degraded */
export const GUIDE_GOAL_DECISION_TIMEOUT_MS = 3000;

/**
 * 弹出前条件需**连续满足**的时长（且期间路由不变）。
 *
 * 付费墙关闭（标记清零）到「购买成功 → 打开续建 Chat」之间有一段空档：PC 的 `router.push('/chat')`
 * 要等导航提交 pathname 才变，H5 的 `hasChatModal` 要等一次 await 之后才置位。不设驻留的话引导会在
 * 空档里抢先弹出并写掉 `seen`，随后被 Chat 盖住或静默收起 —— 用户实际没看到（AC-14）。
 */
export const GUIDE_ELIGIBLE_DWELL_MS = 800;

/** PC 侧栏洞四周外扩（沿用 `PC_SIDE_MENU_HOLE_PAD_PX`，Figma 260→268） */
export const PC_SIDE_MENU_HOLE_PAD_PX = 4;

/** 引导的埋点变体（D20） */
export const ONEPAGE_GUIDE_VARIANT = "onepage";

export type GuideRect = {
  top: number;
  left: number;
  width: number;
  height: number;
};
